import {User} from "@/models/User";

export class Cajero {
    constructor(
        public id: number = 0,
        public ventanilla: number = 0,
        public entidad: string = "",
        public sucursal: string = "",
        public cantidad_factura = 50,
        public user_id: number = 0,

        public rol: string = "cajero",

        public user: User = new User()
    ) {
    }
}